var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClockFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1C1C1A",
  fillRule: "evenodd",
  d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 3a.5.5 0 0 0-1 0v5.5H12a.5.5 0 0 0 0-1H8.5z",
  clipRule: "evenodd"
})));
export { SvgClockFilled as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNiA4QzE2IDEyLjQxODMgMTIuNDE4MyAxNiA4IDE2QzMuNTgxNzIgMTYgMCAxMi40MTgzIDAgOEMwIDMuNTgxNzIgMy41ODE3MiAwIDggMEMxMi40MTgzIDAgMTYgMy41ODE3MiAxNiA4Wk04LjUgM0M4LjUgMi43MjM4NiA4LjI3NjE0IDIuNSA4IDIuNUM3LjcyMzg2IDIuNSA3LjUgMi43MjM4NiA3LjUgM1Y4LjVIMTJDMTIuMjc2MSA4LjUgMTIuNSA4LjI3NjE0IDEyLjUgOEMxMi41IDcuNzIzODYgMTIuMjc2MSA3LjUgMTIgNy41SDguNVYzWiIgZmlsbD0iIzFDMUMxQSIvPgo8L3N2Zz4K";